/** Docs (UA): https://prostopay.atlassian.net/wiki/spaces/SW/pages/1903001625 — ServiceMain */

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate } from 'react-router-dom';

import { ContentBox, PrimaryButton, ScreenTitle, ScreenWrapper } from '../../../../shared/ui';
import { QR_SERVICES } from '../../../../shared/constants';
import { useAppStore } from '../../../../shared/hooks/useAppStore';
import { getVmDetails } from '../../../../shared/lib/general';
import { useFeedbackActions } from '../../../feedback/hooks/useFeedbackActions';
import { usePurchaseActions } from '../../../../shared/hooks/usePurchaseActions';
import { SERVICE_ROUTES } from '../../service.constants';
import styles from './ServiceMain.module.css';

const { ALL_IS_PERMITTED, SEPARATED_SERVICES } = QR_SERVICES;

export const ServiceMain = () => {
    const { t } = useTranslation();
    const { onFeedbackClickHandler, isFeedbackLoading } = useFeedbackActions();
    const { onRepeatPurchaseClickHandler } = usePurchaseActions();
    const navigate = useNavigate();

    const vm = useAppStore((s) => s.vm);
    const { isFridge, isAllowed, isFeedbackEnabled, hasFiscalReceipt } =
        getVmDetails(vm);

    const navigateToRobotPage = () => {
        navigate(generatePath(SERVICE_ROUTES.robot, { id: vm.qr }), {
            replace: true,
        });
    };

    const isReceiptActive = hasFiscalReceipt;
    const isFeedbacksActive = isFeedbackEnabled;

    const isPaymentActive = useMemo(() => {
        if (vm.QRservices === SEPARATED_SERVICES) {
            return false;
        }

        if (vm.QRservices === ALL_IS_PERMITTED && isFridge) {
            return true;
        }

        return isAllowed;
    }, [vm.QRservices, isFridge, isAllowed]);

    return (
        <ScreenWrapper>
            <ScreenTitle>
                {t('Menu')} {vm?.name} {vm?.vmNumber}
            </ScreenTitle>
            <ContentBox>
                <object
                    className={`${styles.svg} ${styles.canvasObject}`}
                    data="/Component.png"
                />

                {isReceiptActive && (
                    <PrimaryButton onClick={navigateToRobotPage}>
                        {t('Get fiscal receipt')}
                    </PrimaryButton>
                )}

                {isFeedbacksActive && (
                    <PrimaryButton
                        onClick={onFeedbackClickHandler}
                        disabled={isFeedbackLoading}
                        loading={isFeedbackLoading}
                    >
                        {t('Feedback')}
                    </PrimaryButton>
                )}

                {isPaymentActive && (
                    <PrimaryButton onClick={() => onRepeatPurchaseClickHandler()}>
                        {t('Buy')}
                    </PrimaryButton>
                )}
            </ContentBox>
        </ScreenWrapper>
    );
};
